var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Edit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.247 3.57153C13.6934 3.57153 13.1398 3.78637 12.7101 4.21604L4.34801 12.5781L4.31495 12.7434L3.73655 15.652L3.57129 16.4287L4.34801 16.2634L7.25656 15.685L7.42182 15.652L15.7839 7.28986C16.6433 6.43051 16.6433 5.07539 15.7839 4.21604C15.3542 3.78637 14.8006 3.57153 14.247 3.57153ZM14.247 4.57961C14.5135 4.57961 14.782 4.70149 15.0403 4.95971C15.5546 5.47408 15.5546 6.03183 15.0403 6.54619L14.6602 6.90976L13.0902 5.3398L13.4538 4.95971C13.712 4.70149 13.9805 4.57961 14.247 4.57961ZM12.3465 6.08347L13.9165 7.65343L7.52098 14.0489C7.17393 13.3714 6.62858 12.826 5.95102 12.479L12.3465 6.08347ZM5.27346 13.3383C5.90764 13.5945 6.40548 14.0923 6.66163 14.7265L4.92641 15.0736L5.27346 13.3383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Edit);
export default __webpack_public_path__ + "static/media/icn_24x24_edit.5f429f4f48fc28b2f0d34a8a9e83dcc9.svg";
export { ForwardRef as ReactComponent };